import VueRouter from "vue-router";

import Login from "./pages/Login";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import EditDetailsPage from "./pages/EditDetails";
import AdminEditDetailsPage from "./pages/AdminEditDetails";
import CustomShiftPage from "./pages/CustomShift";
import AdminViewTimeSheetPage from "./pages/AdminViewTimeSheet";
import AdminContractViewPage from "./pages/AdminContractView";
import AdminViewExcelPage from "./pages/AdminViewExcel";
import store from "./store";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCustomerView from "@/pages/AdminCustomerView";
import AdminCustomerDetail from "@/pages/AdminCustomerDetail";
import AdminUserView from "@/pages/AdminUserView";
import AdminUserDetail from "@/pages/AdminUserDetail";
import UserProfile from "@/pages/UserProfile";
import AdminAbsencesView from "@/pages/AdminAbsencesView";
import AdminVacationView from "@/pages/AdminVacationView";
import AdminViewHourlyRates from "@/pages/AdminViewHourlyRates";
import AdminViewInvoicePreview from "@/pages/AdminViewInvoicePreview";
import AdminContractDetail from "@/pages/AdminContractDetail";
import AdminViewCustomInvoice from "@/pages/AdminViewCustomInvoice";
import AdminInvoiceViewComponent from "@/pages/AdminInvoiceView";
import AdminInvoiceDetail from "@/pages/AdminInvoiceDetail.vue";
import AdminConfirmedEmailOverview from "@/pages/AdminConfirmedEmailOverview.vue";
import UserViewRecup from "@/pages/UserViewRecup.vue";

const routes = [
    {
        name: 'googleOauthEndPoint',
        path: '/googleOauthEndPoint',
        beforeEnter() {
            location.href = process.env.VUE_APP_ROOT_API + '' + '/oauth2/authorize/google?redirect_uri=' + process.env.VUE_APP_REDIRECT_URL;
        },
    },
    {
        name: 'appleOauthEndpoint',
        path: '/appleOauthEndpoint',
        beforeEnter() {
            location.href = process.env.VUE_APP_ROOT_API + '/oauth2/authorize/apple?redirect_uri=' + process.env.VUE_APP_REDIRECT_URL;
        },
    },
    {path: '/', component: Login, name: 'login'},
    {path: '/welcome', component: LandingPage, name: 'landingPage'},
    {path: '/dashboard', component: Dashboard, name: 'dashboard'},
    {path: '/details', component: EditDetailsPage, name: 'details'},
    {path: '/configuration', component: CustomShiftPage},
    {path: '/userViewRecup', component: UserViewRecup},
    {path: '/profile', component: UserProfile, name: 'profile'},
    {path: '/admin/details', component: AdminEditDetailsPage, name: 'adminDetails'},
    {path: '/admin/viewTimeSheet', component: AdminViewTimeSheetPage, name: 'timesheet'},
    {path: '/admin/viewcontracts', component: AdminContractViewPage, name: 'admin'},
    {path: '/admin/viewcontractDetail', component: AdminContractDetail, name: 'adminContractDetail'},
    {path: '/admin/dashboard', component: AdminDashboard, name: 'adminDashboard'},
    {path: '/admin/viewcustomers', component: AdminCustomerView, name: 'adminCustomers'},
    {path: '/admin/viewCustomerDetail', component: AdminCustomerDetail, name: 'adminCustomerDetail'},
    {path: '/admin/viewusers', component: AdminUserView, name: 'adminUsers'},
    {path: '/admin/viewUserDetail', component: AdminUserDetail, name: 'adminUserDetail'},
    {path: '/admin/viewAbsences', component: AdminAbsencesView, name: 'adminAbsences'},
    {path: '/admin/viewexcel', component: AdminViewExcelPage, name: 'adminExcel'},
    {path: '/admin/viewinvoice', component: AdminInvoiceDetail, name: 'adminViewInvoice'},
    {path: '/admin/viewvacation', component: AdminVacationView, name: 'adminVacationView'},
    {path: '/admin/viewHourlyRates', component: AdminViewHourlyRates, name: 'adminViewHourlyRates'},
    {path: '/admin/viewinvoicePreview', component: AdminViewInvoicePreview, name: 'adminViewInvoicePreview'},
    {path: '/admin/viewcustominvoice', component: AdminViewCustomInvoice, name: 'adminViewCustomInvoice'},
    {path: '/admin/viewinvoices', component: AdminInvoiceViewComponent, name: 'adminInvoiceViewComponent'},
    {path: '/admin/viewinvoicedetail', component: AdminInvoiceDetail, name: 'adminInvoiceDetail'},
    {path: '/admin/viewconfirmedemailoverview', component: AdminConfirmedEmailOverview, name: 'adminConfirmedEmailOverview'},
    {
        path: '/admin/viewTimeSheet/:contractId/:yearthMonth',
        component: AdminViewTimeSheetPage,
        redirect: {name: 'timesheet'}
    },
    {path: '*', redirect: {name: 'login'}}
];
const unauthorizedRouteNames = ['login', 'googleOauthEndPoint', 'appleOauthEndpoint'];
const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior() {
        window.scrollTo(0,0);
    }
});

router.beforeEach(async (to, from, next) => {
    const token = router.app.$cookies.get(router.app.$JWT_COOKIENAME);

    if (token && !store.getters['authentication/backendAuthenticated']) {
        //USE-CASE: REFRESH OF THE BROWSER
        await store.dispatch("authentication/setAuthentication", token);
    }

    if (!unauthorizedRouteNames.includes(to.name) && !store.getters['authentication/backendAuthenticated']) {
        next({name: 'login'});
    } else {
        next();
    }
});

export default router;
